// Katarina — Death Lotus: spins in place and hurls a dagger at every enemy,
// hitting all of them regardless of range. No dash — pure assassin reach.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const KAT_WINDUP_MS  = 400; // hex-highlight duration before first dagger
export const KAT_STAGGER_MS = 150; // delay between successive daggers
export const KAT_TRAVEL_MS  = 200; // dagger travel time

export const katarinaDeathLotus: Ability = {
  id: "katarinaDeathLotus",
  displayName: "Death Lotus",
  description: "Spins and hurls daggers at every enemy simultaneously, dealing magic damage to all.",
  iconId: "KatarinaDeathLotus",

  targetShape(ctx) {
    const enemies = ctx.combat.livingUnitsOf(
      ctx.caster.team === "player" ? "enemy" : "player",
    );
    return [ctx.caster.pos, ...enemies.map((e) => e.pos)];
  },

  computeHits(ctx) {
    const enemies = ctx.combat.livingUnitsOf(
      ctx.caster.team === "player" ? "enemy" : "player",
    );
    if (enemies.length === 0) return [];
    const stats = effectiveStats(ctx.caster);

    return enemies.map<AbilityHit>((target, i) => ({
      target,
      amount: magicDamage(stats.ap * 1.1 + 70),
      type: "magical",
      suppressPopup: true,
      katarinaSlice: true,
      delayMs: KAT_WINDUP_MS + i * KAT_STAGGER_MS + KAT_TRAVEL_MS,
    }));
  },
};
